import {equals, union} from 'ramda'

import {removeEmpty} from '@vio/core/src/utils/object'

type Params = Record<string, unknown>

/**
 * Keys whose values differ between the preheat params built on the server and the ones
 * the client builds. Empty values count as missing, since page props can't carry them.
 */
export const getPreheatParamsMismatchKeys = (
  serverParams: Params,
  clientParams: Params
): string[] => {
  const server = removeEmpty(serverParams)
  const client = removeEmpty(clientParams)

  return union(Object.keys(server), Object.keys(client))
    .filter(key => !equals(server[key], client[key]))
    .sort()
}
